module.exports = __webpack_public_path__ + "img/j4.d681b1b0.png";